import VxeFormItemComponent from '../form/src/form-item';
import { dynamicApp } from '../dynamics';
export var VxeFormItem = Object.assign(VxeFormItemComponent, {
    install: function (app) {
        app.component(VxeFormItemComponent.name, VxeFormItemComponent);
    }
});
export var FormItem = VxeFormItem;
dynamicApp.component(VxeFormItemComponent.name, VxeFormItemComponent);
export default VxeFormItem;
